import React, { Component } from 'react'
import Link from 'gatsby-link'
import {Title} from '../Title'
import {InfoBlockGrid} from '../InfoBlockGrid'

import './overview-blocks.css'

const nBlocksPerRow = 2;
const nBlocksPerRowMobile = 1;

class OverviewBlocks extends Component {

  render () {
    return (
      <div>
        <InfoBlockGrid
          nCellsPerRowMobile = {nBlocksPerRowMobile}
          nCellsPerRow = {nBlocksPerRow}
          data = {this.props.blocks}
          sizes = {this.props.sizes}
        ></InfoBlockGrid>
      </div>
    );
  }
}


export default {OverviewBlocks}



// WEBPACK FOOTER //
// ./src/components/OverviewBlocks/index.js